export default __webpack_public_path__ + "static/media/AboutSlide2.c04bcccf.jpg";